import { getBackendUrl, getImageUrl } from "@Utils";
import IconComponent from "../../cubeComponent/icons";
import askAQuestion from "../../assets/icons/AskAQuestion.svg";
import bugReport from "../../assets/icons/BugReport.svg";
import suggestAFeature from "../../assets/icons/SuggestAFeature.svg";
import ButtonComponent from "../../cubeComponent/form/ButtonComponent";
import knowledgeBase from "../../assets/icons/KnowledgeBase.svg";
import getHomePageUrl from "../../services/hooks/getHomePageUrl";
import { useDispatch, useSelector } from "react-redux";
import axiosWrapper from "../../services/axiosWrapper";
import css from "./index.module.css";
import { useContext, useEffect, useState, useMemo, useRef } from "react";
import { getUrlForImage } from "../../cubeComponent/constants/globalFunctions";
import { ThemeContext } from "../../ProviderApp";
import { THEME_DARK, THEME_LIGHT } from "../../App.constant";
import { useNavigate } from "react-router-dom";
import { CiChat1 } from "react-icons/ci";
import { updateSupportChatProperties } from "../../services/utils/freshChatHelper";
import useResetAuth from "../../services/hooks/resetAuth";
import { useTranslation } from "react-i18next";
import _ from "lodash";
import UserNameTagComponent from "../../cubeComponent/html/UserNameTagComponent";
import { supportTicketTypes } from "@Helpers";
import { getAllNotificationPageUrl } from "@Services/utils/helpers";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import PropTypes from "prop-types";
import MenuComponent from "@CubeComponents/html/MenuComponent";
import PopperComponent from "@CubeComponents/html/PopperComponent";
import MenuItemComponent from "@CubeComponents/html/MenuItemComponent";
import { setHelpSectionState } from "@Actions/portalDashboard";
import { Box, Link } from "@mui/material";

function ProfileSideBar({ handleClose }) {
  const { t } = useTranslation();
  const resetAuth = useResetAuth();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userDetails, layout, portalData, userPermissions } = useSelector((state) => state);
  const [homePageUrl] = getHomePageUrl();
  const [showSettings, setShowSettings] = useState(true);
  const themeContext = useContext(ThemeContext);
  const [userPortalList, setUserPortalList] = useState([]);

  const [anchorEl, setAnchorEl] = useState(null);
  const [switchMenuAnchor, setSwitchMenuAnchor] = useState(null);
  const [createMenuAnchor, setCreateMenuAnchor] = useState(null);
  const [isCreatePortalDropDownOpen, setIsCreatePortalDropDownOpen] = useState(false);

  const switchItemRef = useRef(null);
  const createItemRef = useRef(null);

  const isMultiplePortals = useMemo(() => userPortalList.length > 1, [userPortalList]);
  const isChannelPartner = useMemo(() => Boolean(userDetails.partnerData), [userDetails]);

  const handleMainClick = (event) => {
    setAnchorEl(event.currentTarget);
    setIsCreatePortalDropDownOpen(!isCreatePortalDropDownOpen);
    setSwitchMenuAnchor(null);
    setCreateMenuAnchor(null);
  };

  const handleCloseAll = () => {
    setAnchorEl(null);
    setSwitchMenuAnchor(null);
    setCreateMenuAnchor(null);
    setIsCreatePortalDropDownOpen(false);
  };

  const handleSwitchHover = () => {
    if (isMultiplePortals) {
      setSwitchMenuAnchor(switchItemRef.current);
      setCreateMenuAnchor(null);
    }
  };

  const handleCreateHover = () => {
    if (isChannelPartner) {
      setCreateMenuAnchor(createItemRef.current);
      setSwitchMenuAnchor(null);
    }
  };

  const handleMouseLeaveSubMenu = () => {
    setSwitchMenuAnchor(null);
    setCreateMenuAnchor(null);
  };

  const [signinData, setSigninData] = useState({});

  const fetchSigninData = async () => {
    const response = await axiosWrapper.post(`${getBackendUrl()}/accounts/getSigninData`, {});
    setSigninData(response.data);
  };

  useEffect(() => {
    fetchSigninData();
  }, []);

  const navigateToSignupFlow = (asPartner = false) => {
    const baseUrl = `${process.env.REACT_APP_ENV == "development" ? "http" : "https"}://${signinData.frontendUrl}`;

    const url = new URL(baseUrl);

    const urlParams = new URLSearchParams(location?.search);

    if (asPartner) {
      const query1 = urlParams.get("asPartner");
      if (!query1) {
        urlParams.set("asPartner", true);
      }

      const query2 = urlParams.get("partnerId");
      const partnerId = userDetails.partnerData?.cf_partner_id;
      if (!query2 && partnerId) {
        urlParams.set("partnerId", partnerId);
      }
    }

    if (location.pathname !== "/signupflow") {
      url.pathname = "/signupflow";
    }
    urlParams.set("createPortal", true);

    url.search = urlParams.toString();

    window.location.href = url.toString();
  };

  const handleCreatePortal = (asPartner = false) => {
    handleCloseAll();

    navigateToSignupFlow(asPartner);
    navigateToSignupFlow(asPartner);
  };

  const handleCreateNewPortal = () => {
    handleCreatePortal(false);
  };

  const handleCreatePortalForPartner = () => {
    handleCreatePortal(true);
  };

  const fetchUserPortalList = async () => {
    const portalData = await axiosWrapper.post(`${getBackendUrl()}/accounts/getUserPortalList`);
    setUserPortalList(portalData.data.data);
  };

  useEffect(() => {
    if (layout.PORTAL_SETTINGS?.ENABLE === false) {
      setShowSettings(false);
    } else if (
      typeof layout.PORTAL_SETTINGS?.ENABLE === "object" &&
      layout.PORTAL_SETTINGS?.ENABLE?.CONDITION?.COMPANY_NAME
    ) {
      setShowSettings(userDetails?.company?.name == layout.PORTAL_SETTINGS?.ENABLE?.CONDITION?.COMPANY_NAME);
    }
    fetchUserPortalList();
  }, []);

  useEffect(() => {
    const permissions = _.get(userPermissions, "RESOURCE_TYPE_PORTAL.permissions", []);
    const hasAccess = _.includes(permissions, "ACCESS_PORTAL_SETTINGS");
    if (showSettings && !hasAccess) {
      setShowSettings(false);
    }
  }, [userPermissions]);

  const getOrgImage = () => {
    let orgImage = getImageUrl() + layout.PROJECT_LOGO;
    if (userDetails?.company?.logo) {
      orgImage = getUrlForImage({ id: userDetails.company.id }, "organization");
    }
    return orgImage;
  };

  const getProfile = (type) => {
    return <UserNameTagComponent showAvatarOnly id={userDetails._id} size={type} isCircle />;
  };

  const handleLinkClick = (e) => {
    if (e.target.id == "knowledgeBase") {
      dispatch(setHelpSectionState(true));
    } else {
      handleClose();
      const currentUrl = `${window.location.href}`;
      const url = getAllNotificationPageUrl({
        section: "support",
        supportType: e.target.id.toLowerCase(),
        referrerUrl: currentUrl,
      });
      navigate(url);
    }
  };

  const handleEditProfileClick = () => {
    handleClose();
    navigate("/user-profile/personalInformation");
  };

  const handleCompanySettingsClick = () => {
    if (!showSettings) {
      return;
    }
    handleClose();
    if (_.get(userDetails, "company.id")) {
      navigate(`/companySettings/${userDetails.company.id}/details`);
    }
  };

  const openPortalSetting = () => {
    if (!showSettings) {
      return;
    }
    navigate("/portalSettings/information");
    handleClose();
  };

  const logoClick = () => {
    navigate(homePageUrl);
  };

  const UI = {
    iconSize: 16,
    arrowSize: 20,
  };

  const styles = {
    flexRow: { display: "flex", alignItems: "center", gap: 8 },
    titleText: {
      fontSize: 14,
      color: "#192048",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    iconRotate: (open) => ({
      width: UI.iconSize,
      height: UI.iconSize,
      transition: "transform 0.2s ease",
      transform: open ? "rotate(180deg)" : "rotate(0deg)",
    }),
    ellipsis: {
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
  };

  const changeTheme = () => {
    if (themeContext.themeType == THEME_LIGHT) {
      themeContext.setTheme(THEME_DARK);
    } else if (themeContext.themeType == THEME_DARK) {
      themeContext.setTheme(THEME_LIGHT);
    }
  };

  const handleSupportChatClick = () => {
    updateSupportChatProperties(userDetails, portalData);
    handleClose();
  };

  const handlePortalSwitch = (args) => {
    window.location.href = `${process.env.REACT_APP_ENV == "development" ? "http" : "https"}://${args.value}/dashboard`;
  };

  return (
    <>
      <Box className={css.profileSideBarOverlay} onClick={handleClose} aria-label="Close Profile Sidebar" />
      <div className={themeContext.themeType == THEME_LIGHT ? css.profileDropdown : css.profileDropdownDark}>
        <div
          className={
            themeContext.themeType == THEME_LIGHT ? css.profileDropdownContent : css.profileDropdownContentDark
          }
        >
          <div className="flex w-full justify-between items-center" data-testid="profileHeader">
            <span className="flex items-center">
              <IconComponent name="healthicons_ui-user-profile" />
              <span className="text-lg font-bold items-center flex ps-4" data-testid="profileText">
                {t("Profile")}
              </span>
            </span>
            <IconComponent cssClass="cursor-pointer" onClick={handleEditProfileClick} name="edit" />
          </div>
          <div className={css.profileDropdownContentInfo} data-testid="profileHeaderContent">
            <div className={css.profileDropdownContentDetails} data-testid="profileContentLogo">
              <Box className={css.avatarInitialsWrapper} onClick={logoClick} data-testid="profileContentLogoIcon">
                {getProfile("LLG")}
              </Box>
            </div>
            <div className={css.profileDropdownContentDetails} data-testid="profileContentDetails">
              <div data-testid="profileUserName" className={css.contentmainText}>
                {`${userDetails?.firstName} ${userDetails?.lastName ? userDetails?.lastName : ""}`}
              </div>
              <div data-testid="profileUserDesignation" className={css.contentgenralText}>
                {userDetails?.designation}
              </div>
              <div data-testid="profileUserEmail" className={css.contentgenralText}>
                {userDetails?.email}
              </div>
            </div>
          </div>
        </div>
        <div
          className={
            themeContext.themeType == THEME_LIGHT ? css.profileDropdownContent : css.profileDropdownContentDark
          }
        >
          <div className="flex w-full justify-between items-center" data-testid="orgHeader">
            <span style={{ display: "flex", justifyComtent: "left" }}>
              <IconComponent name="organisationSVG" />
              <span className="text-lg font-bold items-center flex ps-4" data-testid="orgText">
                {t("Org")}
              </span>
            </span>
            <Box
              style={{
                opacity: showSettings ? 1 : 0.5,
                cursor: showSettings ? "pointer" : "not-allowed",
              }}
              onClick={handleCompanySettingsClick}
              data-testid="orgSettingsIcon"
            >
              <IconComponent name="SettingsIcon" />
            </Box>
          </div>
          <div className={css.profileDropdownContentInfo} data-testid="orgDetailsContentInfo">
            <div className={css.profileDropdownContentDetails} data-testid="orgLogo">
              <div data-testid="orgLogoIcon">
                <Box className="cursor-pointer" onClick={logoClick}>
                  <img className={css.logoSidebarOther} src={getOrgImage()} alt="Logo" />
                </Box>
              </div>
            </div>
            <div className={css.profileDropdownContentDetails} data-testid="orgDetails">
              <div className={css.contentmainText} data-testid="orgCompanyName">
                {userDetails.company?.name}
              </div>
              <div className={css.contentgenralText} data-testid="orgCompanyWebsite">
                {userDetails.company?.website}
              </div>
              {userDetails.company?.roleName && (
                <div className={css.nameClass} data-testid="orgCompanyRole">
                  <IconComponent name="healthicons_ui-user-profile" />
                  <div className={css.contentgenralText}>{userDetails.company?.roleName}</div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div
          className={
            themeContext.themeType == THEME_LIGHT ? css.profileDropdownContent : css.profileDropdownContentDark
          }
        >
          <div className="flex w-full justify-between items-center" data-testid="portalHeader">
            <span style={{ display: "flex", justifyComtent: "left" }}>
              <IconComponent name="jam_computer-alt" />
              <span className="text-lg font-bold items-center flex ps-4" data-testid="portalText">
                {t("Portal")}
              </span>
            </span>
            <span
              style={{
                opacity: showSettings ? 1 : 0.5,
                cursor: showSettings ? "pointer" : "not-allowed",
              }}
              data-testid="portalSettingsIcon"
            >
              <IconComponent onClick={openPortalSetting} name="SettingsIcon" />
            </span>
          </div>
          <div className={css.profileDropdownContentInfo} data-testid="portalContentDetailsInfo">
            <div className={css.profileDropdownContentDetails} data-testid="portalLogo">
              <div data-testid="portalLogoIcon">
                <Box onClick={logoClick} className="cursor-auto">
                  <img
                    className={css.logoSidebarOther}
                    src={
                      layout.ALLOW_PORTAL_LOGO_UPDATE && portalData.logo
                        ? portalData.logoUrl
                        : getImageUrl() + layout.HEADER_LOGO
                    }
                    alt="Logo"
                  />
                </Box>
              </div>
            </div>
            <div className={css.profileDropdownContentDetails} data-testid="portalDetails">
              <div className={css.contentmainText} data-testid="portalName">
                {/* MAIN BUTTON */}
                <ButtonComponent buttonType="textButton" sx={{ maxWidth: "200px" }} onClick={handleMainClick}>
                  <div style={{ ...styles.flexRow, maxWidth: "200px" }}>
                    <span style={styles.titleText}>{portalData?.name}</span>
                    <svg viewBox="0 0 24 24" style={styles.iconRotate(isCreatePortalDropDownOpen)} aria-hidden="true">
                      <path d="M7 10l5 5 5-5z" />
                    </svg>
                  </div>
                </ButtonComponent>

                {/* MAIN MENU (standardized) */}
                <MenuComponent
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={handleCloseAll}
                  width={200}
                  zIndex={1300}
                  anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                >
                  {/* SWITCH */}
                  <MenuItemComponent ref={switchItemRef} disabled={!isMultiplePortals} onMouseEnter={handleSwitchHover}>
                    <span>{t("Switch")}</span>
                    {isMultiplePortals && <ArrowRightIcon sx={{ width: UI.arrowSize, height: UI.arrowSize }} />}
                  </MenuItemComponent>

                  {/* NEW PORTAL */}
                  <MenuItemComponent
                    ref={createItemRef}
                    onMouseEnter={handleCreateHover}
                    onClick={() => {
                      if (!isChannelPartner) handleCreateNewPortal();
                    }}
                    style={styles.flexRow}
                  >
                    {t("New Portal")}
                    {isChannelPartner && <ArrowRightIcon sx={{ width: UI.arrowSize, height: UI.arrowSize }} />}
                  </MenuItemComponent>
                </MenuComponent>

                {/* SWITCH SUBMENU (standardized) */}
                <PopperComponent
                  open={Boolean(switchMenuAnchor)}
                  anchorEl={switchItemRef.current}
                  onClose={handleMouseLeaveSubMenu}
                  zIndex={1400}
                  minWidth={180}
                  maxHeight={300}
                >
                  {userPortalList?.map((portal) => {
                    const key = portal?._id || portal?.frontendUrl;
                    return (
                      <MenuItemComponent
                        key={key}
                        onClick={() => {
                          handlePortalSwitch({ value: portal.frontendUrl });
                          handleCloseAll();
                        }}
                        title={portal?.name}
                        sx={styles.ellipsis}
                      >
                        {portal?.name}
                      </MenuItemComponent>
                    );
                  })}
                </PopperComponent>

                {/* CREATE PORTAL SUBMENU (standardized) */}
                {isChannelPartner && (
                  <PopperComponent
                    open={Boolean(createMenuAnchor)}
                    anchorEl={createItemRef.current}
                    onClose={handleMouseLeaveSubMenu}
                    zIndex={1400}
                    minWidth={180}
                    maxHeight={300}
                  >
                    <MenuItemComponent onClick={handleCreateNewPortal}>{t("Create Portal")}</MenuItemComponent>
                    <MenuItemComponent onClick={handleCreatePortalForPartner}>
                      {t("Create Portal for Customer")}
                    </MenuItemComponent>
                  </PopperComponent>
                )}
              </div>
              <div className={css.contentgenralText} data-testid="portalfrontEndURL">
                {portalData.frontendUrl}
              </div>
              <div className={css.nameClass} data-testid="portalRole">
                <IconComponent name="healthicons_ui-user-profile" />
                <div className={css.contentgenralText} data-testid="portalRoleName">
                  {userDetails.portalRole?.frontendName}
                </div>
              </div>
            </div>
          </div>
        </div>
        {(["development"].includes(process.env.REACT_APP_ENV) || window.location.host.includes(".cube.ms")) && (
          <div className={themeContext.themeType == THEME_LIGHT ? css.linksSection : css.linksSectionDark}>
            <div className={css.profileLinks} data-testid="askAQuestion">
              <div>
                <img src={askAQuestion} data-testid="askAQuestionImg" alt="Ask a Question" />
              </div>
              <Link
                id={supportTicketTypes.ASK_QUESTION}
                onClick={handleLinkClick}
                data-testid="askAQuestionLink"
                component="button"
                underline="none"
                className="text-black hover:text-gradient_color hover:font-semibold cursor-pointer no-underline"
              >
                {t("Ask a Question")}
              </Link>
            </div>
            <div className={css.profileLinks} data-testid="suggestAFeature">
              <div>
                <img src={suggestAFeature} data-testid="suggestAFeatureImg" alt="Suggest a Feature" />
              </div>
              <Link
                id={supportTicketTypes.SUGGEST_A_FEATURE}
                onClick={handleLinkClick}
                className="text-black hover:text-gradient_color hover:font-semibold cursor-pointer no-underline"
                data-testid="suggestAFeatureLink"
                component="button"
                underline="none"
              >
                {t("Suggest a Feature")}
              </Link>
            </div>
            <div className={css.profileLinks} data-testid="reportABug">
              <div>
                <img src={bugReport} data-testid="reportABugImg" alt="Report a Bug" />
              </div>
              <Link
                id={supportTicketTypes.REPORT_A_BUG}
                onClick={handleLinkClick}
                className="text-black hover:text-gradient_color hover:font-semibold cursor-pointer no-underline"
                data-testid="reportABugLink"
                component="button"
                underline="none"
              >
                {t("Report a Bug")}
              </Link>
            </div>
            <div className={css.profileLinks} data-testid="knowledgeBase">
              <div>
                <img src={knowledgeBase} data-testid="knowledgeBaseImg" alt="Knowledge Base" />
              </div>
              <Link
                id="knowledgeBase"
                onClick={handleLinkClick}
                className="text-black hover:text-gradient_color hover:font-semibold cursor-pointer no-underline"
                data-testid="knowledgeBaseLink"
                component="button"
                underline="none"
              >
                {t("Knowledge Base")}
              </Link>
            </div>
            {process.env.REACT_APP_CHAT_URL &&
              !["mpmrcl.app.cube.ms", "cube-pmis.mpmrcl.in"].includes(portalData.frontendUrl) && (
                <div className="cursor-pointer flex items-center gap-4" data-testid="supportChatLink">
                  <CiChat1 />
                  <Link
                    onClick={handleSupportChatClick}
                    component="button"
                    underline="none"
                    className="text-black hover:text-gradient_color hover:font-semibold cursor-pointer no-underline"
                  >
                    {t("Chat with us")}
                  </Link>
                </div>
              )}
          </div>
        )}

        <div className={css.signoutSection} data-testid="signOutBtn">
          <div>
            <ButtonComponent width="100px" onClick={resetAuth}>
              {t("Sign Out")}
            </ButtonComponent>
          </div>
          <div>
            {["qa", "staging", "development"].includes(process.env.REACT_APP_ENV) && (
              <IconComponent
                name={themeContext.themeType == THEME_LIGHT ? "LightTheme_Icon" : "DarkTheme_Icon"}
                onClick={changeTheme}
                cssClass="cursor-pointer"
              />
            )}
          </div>
        </div>
        <div className={css.remSpace}>
          <div className={css.remSpaceItem}>
            <div className={css.boldClass}>
              {t("CUBE v")}
              {process.env.REACT_APP_VERSION}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

ProfileSideBar.propTypes = {
  handleClose: PropTypes.func.isRequired,
};

export default ProfileSideBar;
